require.register("app/restaurant/CreateModal", function(exports, require, module){
  $0
  
});

